import { useSelector } from 'react-redux';
import { isProductisedSignupFlow } from '../utils/gtkm/isProductisedSignupFlow';
export const useIsSU0004Variation = () => useSelector(state => isProductisedSignupFlow(state));